import moment from 'moment';
import wx from 'weixin-js-sdk';
const BASE_DOMAIN = process.env.NODE_ENV === 'production' && window.location.origin.includes('xiaoheihe.cn') ? 'xiaoheihe.cn' : 'debugmode.cn';

export const utils = {
  setHash: function (key, value) {
    var hash_arr = this.getHashArr();
    var has_key = false;
    for (var i = 0; i < hash_arr.length; i++) {
      if (hash_arr[i].key == key) {
        hash_arr[i].value = value;
        has_key = true;
        break;
      }
    }
    if (!has_key) {
      hash_arr.push({ key: key, value: value });
    }
    hash_arr = hash_arr
      .filter((_) => _.value)
      .map((item) => {
        return `${item.key}=${item.value}`;
      });
    var hash = '';
    if (hash_arr.length > 0) {
      hash = '#' + hash_arr.join('&');
    }
    window.location.hash = hash;
  },
  isPC: function () {
    const type = this.getUrlParam('os_type');
    if (type && ['iOS', 'Android', 'webinapp', 'ohos'].includes(type)) {
      return false;
    } else {
      return true;
    }
  },
  getHash: function (key) {
    var hash_arr = this.getHashArr();
    for (var i = 0; i < hash_arr.length; i++) {
      if (hash_arr[i].key == key) {
        return hash_arr[i].value;
      }
    }
    return false;
  },
  getHashArr: function () {
    var hash = window.location.hash.slice(1);
    var hash_arr = [];
    if (hash) {
      hash_arr = hash.split('&');
    }
    hash_arr = hash_arr.map((item) => {
      return { key: item.split('=')[0], value: item.split('=')[1] };
    });
    return hash_arr;
  },
  // 拿到指定url的所有参数  url默认值为 window.location.href
  getParams: function (url) {
    url = url || window.location.href;
    if (!url.match(/\?./g)) {
      return false;
    }
    url = url.split('#')[0];
    return url.match(/([^?=&]+)(=([^&]*))/g).reduce(function (a, v) {
      return (a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a;
    }, {});
  },
  // 拿到url中的具体某个参数的值
  getUrlParam: function (key, url) {
    url = url || window.location.href;
    var self = this;
    var params = this.getParams(url);
    return params[key] ? params[key] : '';
  },
  formDate: function (t, type = 1) {
    // filter type
    // 1 日期带时分秒
    // 2 距离现在过去多久
    // 3 24小时显示内距离现在过去多久,24小时以上显示日期不带时分秒
    // 4 格式化时分，个位数补零
    // 5 返回年月日

    const timeSpan = t * 1000;
    const dateTime = new Date(parseInt(timeSpan));

    const year = dateTime.getFullYear();
    const month = dateTime.getMonth() + 1;
    const day = dateTime.getDate();
    const hour = dateTime.getHours();
    const minute = dateTime.getMinutes();
    const second = dateTime.getSeconds();

    if (type == 1) {
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
    } else if (type == 4) {
      let _hour = hour < 10 ? '0' + hour : hour;
      let _minute = minute < 10 ? '0' + minute : minute;
      return year + '-' + month + '-' + day + ' ' + _hour + ':' + _minute;
    } else if (type == 5) {
      let _month = month;
      let _day = day;
      if (month < 10) {
        _month = '0' + _month;
      }
      if (_day < 10) {
        _day = '0' + _day;
      }
      return year + '-' + _month + '-' + _day;
    } else {
      const now = new Date();
      const now_new = Date.parse(now);

      const ms = now_new - timeSpan;
      let timeSpanStr;

      if (ms <= 1000 * 60 * 1) {
        timeSpanStr = '刚刚';
      } else if (1000 * 60 * 1 < ms && ms <= 1000 * 60 * 60) {
        timeSpanStr = Math.round(ms / (1000 * 60)) + '分钟前';
      } else if (1000 * 60 * 60 * 1 < ms && ms <= 1000 * 60 * 60 * 24) {
        timeSpanStr = Math.round(ms / (1000 * 60 * 60)) + '小时前';
      } else {
        if (type == 2) {
          if (1000 * 60 * 60 * 24 < ms && ms <= 1000 * 60 * 60 * 24 * 30) {
            timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24)) + '天前';
          } else if (1000 * 60 * 60 * 24 * 30 < ms && ms <= 1000 * 60 * 60 * 24 * 365) {
            timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24 * 30)) + '月前';
          } else {
            timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24 * 365)) + '年前';
          }
        } else if (type == 3) {
          timeSpanStr = year + '-' + month + '-' + day;
        }
      }
      return timeSpanStr;
    }
  },
  // 模版化时间
  formatDateByTemplet(time = 'now', format = 'yyyy-mm-dd hh:nn') {
    // 规则
    // yyyy是整年份如2022, yy是最后两位如 2022年就是22
    // mm为个位月份补0，如 8月就是 08， m就是直接显示月份
    // d为天数 h为小时 n为分钟 规则与月份相同

    // 参数说明
    // time 单位为秒
    // 不传参数默认 按 2022-10-12 10:22 这种格式返回当前时间
    // time 为 'now' 时可传第二个参数，来格式化当前时间

    const _date = time == 'now' ? new Date() : new Date(time * 1000),
      year = _date.getFullYear(),
      month = _date.getMonth() + 1,
      day = _date.getDate(),
      hour = _date.getHours(),
      minute = _date.getMinutes();

    const formatTime = (num) => {
      if (num < 10) {
        return '0' + num;
      } else {
        return num;
      }
    };
    let pattern = /(y+)|(m+)|(d+)|(h+)|(n+)/g;
    let match;
    while ((match = pattern.exec(format))) {
      let match_word = match[0];
      if (/y/.test(match_word)) {
        if (match_word == 'yy') {
          format = format.replace(match_word, year % 100);
        } else {
          format = format.replace(match_word, year);
        }
      } else if (/m/.test(match_word)) {
        if (match_word == 'mm') {
          format = format.replace(match_word, formatTime(month));
        } else {
          format = format.replace(match_word, month);
        }
      } else if (/d/.test(match_word)) {
        if (match_word == 'dd') {
          format = format.replace(match_word, formatTime(day));
        } else {
          format = format.replace(match_word, day);
        }
      } else if (/h/.test(match_word)) {
        if (match_word == 'hh') {
          format = format.replace(match_word, formatTime(hour));
        } else {
          format = format.replace(match_word, hour);
        }
      } else if (/n/.test(match_word)) {
        if (match_word == 'nn') {
          format = format.replace(match_word, formatTime(minute));
        } else {
          format = format.replace(match_word, minute);
        }
      }
    }
    return format;
  },
  // 版本比较，是否大于等于目标版本 ge：大于等于 le：小于等于
  geVersion: function (targetVersion, currentVersion = this.getUrlParam('version')) {
    return _countVersion(currentVersion) >= _countVersion(targetVersion);
    function _countVersion(version) {
      return version.split('.').reduce(function (a, b) {
        return ~~a * 1000 + ~~b;
      });
    }
  },
  showMessage: function (state, msg) {
    window.location.href =
      'heybox://' +
      encodeURIComponent(
        JSON.stringify({
          protocol_type: 'alert',
          alert_type: 'state',
          state: state,
          desc: msg,
        }),
      );
  },
  isFullScreen: function () {
    let result = false;
    let rate = window.screen.height / window.screen.width;
    let limit = window.screen.height == window.screen.availHeight ? 1.85 : 1.65;
    if (rate > limit) {
      result = true;
    }
    return result;
  },
  getOSType: function () {
    if (window && window.navigator.userAgent) {
      const ua = window.navigator.userAgent.toLocaleLowerCase();
      if (/(iphone|ipad|ios)/i.test(ua)) {
        return 'iOS';
      } else if (/mac os/i.test(ua)) {
        return 'Mac';
      } else if (/(android)/i.test(ua)) {
        return 'Android';
      } else if (/(harmony|arkweb)/i.test(ua)) {
        return 'ohos';
      } else {
        return 'Windows';
      }
    }
    return '';
  },
  wxShare: function (data, share) {
    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'],
    });

    wx.ready(function () {
      // 微信jssdk 1.6.0新增 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.updateAppMessageShareData({
        title: share.title,
        desc: share.desc,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {},
      });

      // 微信jssdk 1.6.0新增 自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容
      wx.updateTimelineShareData({
        title: share.title,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {},
      });

      //分享到腾讯微博
      wx.onMenuShareWeibo({
        title: share.title,
        desc: share.desc,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {},
        cancel: function () {},
      });
    });
  },
  // 在app外执行协议
  executeProtocolOutApp(protocol) {
    const ua = window.navigator.userAgent.toLowerCase();
    const client_type = this.getUrlParam('client_type');
    let formatProtocol = '';
    if (JSON.stringify(protocol).includes('heybox://') || JSON.stringify(protocol).includes('heybox%3A%2F%2F')) {
      formatProtocol = protocol;
    } else {
      formatProtocol = 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    }
    if (/QQ/i.test(ua) || /Weibo/i.test(ua) || /Android/i.test(ua)) {
      window.location.href = window.location.origin + '/open_inapp/#' + formatProtocol;
    } else {
      let host = client_type == 'acc_mobile' ? 'acc.xiaoheihe.cn' : 'c.xiaoheihe.cn';
      window.location.href = 'https://' + host + '/hb_protocol?protocol=' + formatProtocol;
    }
  },
  // 执行协议异步
  executeProtocol: function (protocol) {
    if (process.env.NODE_ENV == 'development') {
      console.log('🚀 invokle protocol:', protocol);
      return;
    }
    if (protocol.constructor == String && protocol.indexOf('heybox://') != -1) {
      protocol = JSON.parse(decodeURIComponent(protocol.replace('heybox://', '')));
    }
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.hbProtocol) {
      window.webkit.messageHandlers.hbProtocol.postMessage(protocol);
    } else if (window.local_obj && window.local_obj.hbProtocol) {
      window.local_obj.hbProtocol('heybox://' + encodeURIComponent(JSON.stringify(protocol)));
    } else {
      window.location.href = 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    }
  },
  // 同步执行协议
  executeProtocolSync: function (protocol) {
    if (process.env.NODE_ENV == 'development') {
      return 88;
    }
    return prompt(' ', 'heybox://' + encodeURIComponent(JSON.stringify(protocol)));
  },
  // 十六进制转为 rgba的模式
  hexToRgba(hex, opacity = 1) {
    if (hex) {
      hex = hex.toUpperCase();
      if (hex.length === 4) {
        hex =
          '#' +
          hex
            .split('#')[1]
            .split('')
            .map((item) => item.repeat(2))
            .join('');
      }
      return (
        'rgba(' +
        parseInt('0x' + hex.slice(1, 3)) +
        ',' +
        parseInt('0x' + hex.slice(3, 5)) +
        ',' +
        parseInt('0x' + hex.slice(5, 7)) +
        ',' +
        opacity +
        ')'
      );
    }
  },
  pageChange: function (enterCallback = () => {}, leaveCallback = () => {}) {
    var state, visibilityChange;
    if (typeof document.hidden !== 'undefined') {
      visibilityChange = 'visibilitychange';
      state = 'visibilityState';
    } else if (typeof document.mozHidden !== 'undefined') {
      visibilityChange = 'mozvisibilitychange';
      state = 'mozVisibilityState';
    } else if (typeof document.msHidden !== 'undefined') {
      visibilityChange = 'msvisibilitychange';
      state = 'msVisibilityState';
    } else if (typeof document.webkitHidden !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange';
      state = 'webkitVisibilityState';
    }
    document.addEventListener(
      visibilityChange,
      function () {
        if (document[state] == 'visible') {
          // 回来页面
          setTimeout(() => {
            enterCallback();
          }, 50);
        }
        if (document[state] == 'hidden') {
          // 离开页面
          leaveCallback();
        }
      },
      false,
    );
  },
  deepCopy(data) {
    let dataTmp = undefined;
    if (data === null || !(typeof data === 'object')) {
      dataTmp = data;
    } else {
      dataTmp = data.constructor.name === 'Array' ? [] : {};
      for (let key in data) {
        dataTmp[key] = utils.deepCopy(data[key]);
      }
    }
    return dataTmp;
  },
  //预加载图片
  prefetchImage(imgs) {
    return new Promise((resolve, reject) => {
      let count = 0,
        len = imgs.length;
      for (let i = 0; i < len; i++) {
        let img = new Image();
        img.src = imgs[i];
        img.onload = function () {
          count++;
          if (count === len) {
            resolve('prefetch');
          }
        };
        img.onerror = function () {
          reject(`${imgs[i]} failed to load`);
        };
      }
    });
  },
  // supportWebp: false,
  webpFormat(urlObj, quality) {
    let _this = this;
    return new Promise((resolve) => {
      if (window.SUPPORT_WEBP) {
        urlObj = _this.formatWebpParams(urlObj, quality);
        resolve(urlObj);
      } else {
        var img = new Image();
        img.onload = function () {
          var result = img.width > 0 && img.height > 0;
          if (result) {
            window.SUPPORT_WEBP = true;
            urlObj = _this.formatWebpParams(urlObj, quality);
          }
          resolve(urlObj);
        };
        img.onerror = function () {
          window.SUPPORT_WEBP = false;
          resolve(urlObj);
        };
        img.src =
          'data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA';
      }
    });
  },
  formatWebpParams(urlObj, quality = 75) {
    let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com\/.*(?!\.(svg|svgz|ico)$)/;
    if (window.SUPPORT_WEBP) {
      if (typeof urlObj === 'object') {
        Object.keys(urlObj).forEach((key) => {
          if (cdnReg.test(urlObj[key])) {
            let url = urlObj[key].split('?')[0];
            urlObj[key] = `${url}?imageMogr2/format/webp/quality/${quality}/ignore-error/1`;
          }
        });
      } else if (urlObj) {
        if (cdnReg.test(urlObj)) {
          let url = urlObj.split('?')[0];
          urlObj = `${url}?imageMogr2/format/webp/quality/${quality}/ignore-error/1`;
        }
      }
    }
    return urlObj;
  },
  // y轴先快后慢滚动到指定位置
  easeOutScrollTo(position = 0, el = null) {
    return new Promise((resolve) => {
      // 不存在原生requestAnimationFrame，用setTimeout模拟替代
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (cb) {
          return setTimeout(cb, 17);
        };
      }
      // 当前滚动高度
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (el) {
        // 容器内滚动情况
        scrollTop = el.scrollTop;
      }
      var step = function () {
        const distance = position - scrollTop;
        scrollTop = scrollTop + distance / 5;
        if (Math.abs(distance) < 1) {
          if (el) {
            el.scrollTo(0, position);
          } else {
            window.scrollTo(0, position);
          }
          // 滚动结束
          setTimeout(() => {
            resolve(1);
          }, 18);
        } else {
          if (el) {
            el.scrollTo(0, scrollTop);
          } else {
            window.scrollTo(0, scrollTop);
          }
          requestAnimationFrame(step);
        }
      };
      step();
    });
  },
  getDomByJson(rich, type = 'dom') {
    // 设置属性元组
    const styleMap = {
      width: 'width',
      height: 'height',
      font_name: 'font-family',
      font_size: 'font-size',
      background_color: 'background-color',
      line_height: 'line-height',
      underline_color: 'text-decoration: underline; text-decoration-color',
      color: 'color',
      corner_radius: 'border-radius',
      border_width: 'border-style: solid; border-width',
      border_color: 'border-color',
      text_alignment: 'text-align',
      number_of_lines: 'white-space',
    };
    const valMap = {
      text_alignment: { 0: 'left', 1: 'center' },
      number_of_lines: { 0: 'normal', 1: 'nowrap' },
    };
    let needScale = false;
    let _rich = JSON.parse(JSON.stringify(rich));

    // 查询是否需要缩放
    (function () {
      for (let child of _rich.attrs) {
        if (child.font_size < 10 || _rich.border_width < 1) {
          needScale = true;
        }
      }
      if (needScale) {
        for (let item of _rich.attrs) {
          if (item.font_size) {
            item.font_size *= 2;
          }
          if (item.font_weight) {
            item.font_weight *= 2;
          }
          if (item.width) {
            item.width *= 2;
          }
          if (item.height) {
            item.height *= 2;
          }
        }
        _rich.border_width *= 2;
        _rich.corner_radius *= 2;
        if (_rich.inset) {
          _rich.inset.top *= 2;
          _rich.inset.bottom *= 2;
          _rich.inset.left *= 2;
          _rich.inset.right *= 2;
        }
      }
    })();

    // 添加属性的函数
    const addStyle = function (_rich) {
      let style = '';
      for (let k in _rich) {
        if (k in styleMap) {
          let key = styleMap[k];
          let val = valMap[k] ? valMap[k][_rich[k]] : _rich[k];
          if (typeof val === 'number') {
            val += 'px';
          }
          if (key.match('color')) {
            if (val.indexOf('#') != -1) {
              if (val.length == 9) {
                let a = parseInt(val.slice(1, 3), 16) / 255;
                let r = parseInt(val.slice(3, 5), 16);
                let g = parseInt(val.slice(5, 7), 16);
                let b = parseInt(val.slice(7), 16);
                val = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
              } else {
                let r = parseInt(val.slice(1, 3), 16);
                let g = parseInt(val.slice(3, 5), 16);
                let b = parseInt(val.slice(5), 16);
                val = 'rgba(' + r + ',' + g + ',' + b + ',' + 1 + ')';
              }
            }
          }
          style += key + ':' + val + ';';
        }
      }
      if (_rich.inset) {
        let padding = { top: 0, left: 0, bottom: 0, right: 0, ..._rich.inset };
        style += `padding:${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px;`;
      }
      return style;
    };

    // 添加主dom
    const dom = document.createElement('div');

    // 添加内部元素
    for (let child of _rich.attrs) {
      let childEl;
      switch (child.type) {
        case 'text': {
          childEl = document.createElement('p');
          let style = addStyle(child);
          style += ` white-space: nowrap;`;
          if (child.offset) {
            style += `position: relative; top:${child.offset}px;`;
          }
          childEl.innerText = child.text;
          childEl.style = style;
          break;
        }
        case 'spacer':
          childEl = document.createElement('span');
          childEl.style = addStyle(child) + 'display: inline-block;';
          break;
        case 'image':
          childEl = document.createElement('img');
          childEl.src = child.image;
          childEl.style = addStyle(child) + 'vertical-align: bottom;';
          break;
      }
      dom.appendChild(childEl);
    }

    // 处理父元素样式
    let outerDomStyle = addStyle(_rich);
    if (!_rich.number_of_lines || _rich.number_of_lines === 1) {
      outerDomStyle += `display: inline-flex; justify-content: center;`;
    }
    if (needScale) {
      if (type == 'post') {
        // outerDomStyle += ` transform: scale(0.5); transform-origin: left center;`
      } else {
        outerDomStyle += ` transform: scale(0.5); transform-origin: left top;`;
      }
    }
    switch (_rich.text_alignment) {
      case 0:
        outerDomStyle += `align-items: flex-start;`;
        break;
      case 1:
        outerDomStyle += `align-items: center;`;
        break;
      default:
        outerDomStyle += `align-items: center;`;
    }

    dom.style = outerDomStyle;
    if (_rich.protocol) {
      dom.addEventListener('click', () => {
        window.location.href = _rich.protocol;
      });
    }

    let result = type == 'dom' ? dom : dom.outerHTML;
    return result;
  },
  // 获取环境类型
  getEnvType() {
    if (process.env.NODE_ENV === 'production') {
      const url = window.location.href;
      if (url.startsWith('https://heybox.debugmode.cn')) {
        return 'test';
      }
      if (url.startsWith('https://api.xiaoheihe.cn')) {
        return 'pro';
      }
    }
    return 'dev';
  },
  getUrlOrigin() {
    return window.location.origin;
  },
  // cookie操作
  setCookie(name, value) {
    var now = new Date();
    now.setTime(now.getTime() + 14 * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + escape(value) + ';expires=' + now.toGMTString() + ';path=/;domain=' + BASE_DOMAIN;
  },
  getCookie(name) {
    const arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
    if (arr != null) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  delCookie(name) {
    let now = new Date();
    now.setTime(now.getTime() - 100000);
    const cval = utils.getCookie(name);
    if (cval != null) {
      document.cookie = name + '=;expires=' + now.toGMTString() + ';path=/;domain=' + BASE_DOMAIN;
    }
  },
  //  显示新版Toast
  showToast(msg, type = 'ok') {
    if (this.geVersion('1.3.237')) {
      this.executeProtocol({
        protocol_type: 'showToast',
        type: '1',
        text: msg,
      });
    } else {
      this.showMessage(type, msg);
    }
  },
  // 处理请求指向
  getRequestUrl(path, add_host = true) {
    const white_list = ['webtest', 'login', 'localhost', 'chat', 'hkoa', 'accoriapi', 'accapi'];
    if (white_list.find((host) => window.location.origin.includes(host)) || window.location.origin.match(/\./g).length >= 3) {
      return path;
    }

    // 请求完整url
    if (path.startsWith('http')) {
      if (add_host) {
        return path;
      } else {
        return new URL(path).pathname;
      }
    }

    return window.location.origin.replace(/(.*?:\/\/)(.*?)\.(.*?)(\..*)/, (url, protocol, prefix_host, host, suffix_host) => {
      let temp_host = '';
      if (host == 'xiaoheihe') {
        temp_host = protocol + 'api.' + host + suffix_host;
      } else if (host == 'debugmode') {
        temp_host = protocol + 'heybox.' + host + suffix_host;
      }
      return add_host ? temp_host + path : path.replace(temp_host, '');
    });
  },

  /**
   * 获取当前环境
   * @returns {
   *  user_id: 123456,
   *  version: 'xxx',
   *  os_type: 'Android' or 'iOS'
   * }
   */
  getHeyboxEnv(ignore_version = false) {
    if (ignore_version || this.geVersion('1.3.261')) {
      // Android
      if (window.local_obj && window.local_obj.getHeyboxEnv) {
        const temp = window.local_obj.getHeyboxEnv() || '{}';
        return JSON.parse(temp);
      }
      // IOS
      return window.HEYBOX_ENV || {};
    }
    return {};
  },

  // 判断是否在小黑盒
  isInHeybox() {
    const env = this.getHeyboxEnv();
    return env && Object.entries(env).length > 0;
  },

  // 给对象数组去重，指定key
  uniqueObjectArray(originalArray, key) {
    const uniqueArray = [];
    const keySet = {};

    for (const item of originalArray) {
      if (!keySet[item[key]]) {
        uniqueArray.push(item);
        keySet[item[key]] = true;
      }
    }
    return uniqueArray;
  },
};

// 设置window.location.hash
export function setHash(key, value) {
  var hash_arr = getHashArr();
  var has_key = false;
  for (var i = 0; i < hash_arr.length; i++) {
    if (hash_arr[i].key == key) {
      hash_arr[i].value = value;
      has_key = true;
      break;
    }
  }
  if (!has_key) {
    hash_arr.push({ key: key, value: value });
  }
  hash_arr = hash_arr
    .filter((_) => _.value)
    .map((item) => {
      return `${item.key}=${item.value}`;
    });
  var hash = '';
  if (hash_arr.length > 0) {
    hash = '#' + hash_arr.join('&');
  }
  window.location.hash = hash;
}

// 判断是否是PC
export function isPC() {
  const type = getUrlParam('os_type');
  if (type && ['iOS', 'Android', 'webinapp', 'ohos'].includes(type)) {
    return false;
  } else {
    return true;
  }
}

// 根据key获取hash
export function getHash(key) {
  var hash_arr = getHashArr();
  for (var i = 0; i < hash_arr.length; i++) {
    if (hash_arr[i].key == key) {
      return hash_arr[i].value;
    }
  }
  return false;
}

// 获取window.location.hash
export function getHashArr() {
  var hash = window.location.hash.slice(1);
  var hash_arr = [];
  if (hash) {
    hash_arr = hash.split('&');
  }
  hash_arr = hash_arr.map((item) => {
    return { key: item.split('=')[0], value: item.split('=')[1] };
  });
  return hash_arr;
}

// 拿到指定url的所有参数  url默认值为 window.location.href
export function getParams(url) {
  url = url || window.location.href;
  if (!url.match(/\?.*=/g)) {
    return false;
  }
  url = url.split('#')[0];
  return (url.match(/([^?=&]+)(=([^&]*))/g) ?? []).reduce(function (a, v) {
    return (a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a;
  }, {});
}

// 拿到url中的具体某个参数的值
export function getUrlParam(key, url) {
  url = url || window.location.href;
  var params = getParams(url);
  return params[key] ? params[key] : '';
}

export function getDecodeUrlParam(key, url) {
  return decodeURIComponent(getUrlParam(key, url));
}

// 根据制定类型格式化时间
export function formDate(t, type = 1) {
  // filter type
  // 1 日期带时分秒
  // 2 距离现在过去多久
  // 3 24小时显示内距离现在过去多久,24小时以上显示日期不带时分秒
  // 4 格式化时分，个位数补零
  // 5 返回年月日
  // 6 距离给定时间还有多久

  const timeSpan = t * 1000;
  const dateTime = new Date(parseInt(timeSpan));

  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1;
  const day = dateTime.getDate();
  const hour = dateTime.getHours();
  const minute = dateTime.getMinutes();
  const second = dateTime.getSeconds();

  if (type == 1) {
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  } else if (type == 4) {
    let _hour = hour < 10 ? '0' + hour : hour;
    let _minute = minute < 10 ? '0' + minute : minute;
    return year + '-' + month + '-' + day + ' ' + _hour + ':' + _minute;
  } else if (type == 5) {
    let _month = month;
    let _day = day;
    if (month < 10) {
      _month = '0' + _month;
    }
    if (_day < 10) {
      _day = '0' + _day;
    }
    return year + '-' + _month + '-' + _day;
  } else if (type == 6) {
    const now = new Date();
    const diff = timeSpan - now.getTime();
    let timeSpanStr;
    if (diff <= 1000 * 60) {
      timeSpanStr = '1分钟内';
    } else if (1000 * 60 < diff && diff <= 1000 * 60 * 60) {
      timeSpanStr = Math.round(diff / (1000 * 60)) + '分钟后';
    } else if (1000 * 60 * 60 < diff && diff <= 1000 * 60 * 60 * 24) {
      timeSpanStr = Math.round(diff / (1000 * 60 * 60)) + '小时后';
    } else if (1000 * 60 * 60 * 24 < diff && diff <= 1000 * 60 * 60 * 24 * 10) {
      timeSpanStr = Math.round(diff / (1000 * 60 * 60 * 24)) + '天后';
    } else {
      timeSpanStr = year + '-' + month + '-' + day;
    }
    return timeSpanStr;
  } else {
    const now = new Date();
    const now_new = Date.parse(now);

    const ms = now_new - timeSpan;
    let timeSpanStr;

    if (ms <= 1000 * 60 * 1) {
      timeSpanStr = '刚刚';
    } else if (1000 * 60 * 1 < ms && ms <= 1000 * 60 * 60) {
      timeSpanStr = Math.round(ms / (1000 * 60)) + '分钟前';
    } else if (1000 * 60 * 60 * 1 < ms && ms <= 1000 * 60 * 60 * 24) {
      timeSpanStr = Math.round(ms / (1000 * 60 * 60)) + '小时前';
    } else {
      if (type == 2) {
        if (1000 * 60 * 60 * 24 < ms && ms <= 1000 * 60 * 60 * 24 * 30) {
          timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24)) + '天前';
        } else if (1000 * 60 * 60 * 24 * 30 < ms && ms <= 1000 * 60 * 60 * 24 * 365) {
          timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24 * 30)) + '月前';
        } else {
          timeSpanStr = Math.round(ms / (1000 * 60 * 60 * 24 * 365)) + '年前';
        }
      } else if (type == 3) {
        timeSpanStr = year + '-' + month + '-' + day;
      }
    }
    return timeSpanStr;
  }
}

// 模版化时间
export function formatDateByTemplet(time = 'now', format = 'yyyy-mm-dd hh:nn') {
  // 规则
  // yyyy是整年份如2022, yy是最后两位如 2022年就是22
  // mm为个位月份补0，如 8月就是 08， m就是直接显示月份
  // d为天数 h为小时 n为分钟 规则与月份相同

  // 参数说明
  // time 单位为秒
  // 不传参数默认 按 2022-10-12 10:22 这种格式返回当前时间
  // time 为 'now' 时可传第二个参数，来格式化当前时间

  const _date = time == 'now' ? new Date() : new Date(time * 1000),
    year = _date.getFullYear(),
    month = _date.getMonth() + 1,
    day = _date.getDate(),
    hour = _date.getHours(),
    minute = _date.getMinutes();

  const formatTime = (num) => {
    if (num < 10) {
      return '0' + num;
    } else {
      return num;
    }
  };
  let pattern = /(y+)|(m+)|(d+)|(h+)|(n+)/g;
  let match;
  while ((match = pattern.exec(format))) {
    let match_word = match[0];
    if (/y/.test(match_word)) {
      if (match_word == 'yy') {
        format = format.replace(match_word, year % 100);
      } else {
        format = format.replace(match_word, year);
      }
    } else if (/m/.test(match_word)) {
      if (match_word == 'mm') {
        format = format.replace(match_word, formatTime(month));
      } else {
        format = format.replace(match_word, month);
      }
    } else if (/d/.test(match_word)) {
      if (match_word == 'dd') {
        format = format.replace(match_word, formatTime(day));
      } else {
        format = format.replace(match_word, day);
      }
    } else if (/h/.test(match_word)) {
      if (match_word == 'hh') {
        format = format.replace(match_word, formatTime(hour));
      } else {
        format = format.replace(match_word, hour);
      }
    } else if (/n/.test(match_word)) {
      if (match_word == 'nn') {
        format = format.replace(match_word, formatTime(minute));
      } else {
        format = format.replace(match_word, minute);
      }
    }
  }
  return format;
}

// 版本比较，是否大于等于目标版本 ge：大于等于 le：小于等于
export function geVersion(targetVersion, currentVersion = getUrlParam('version')) {
  return _countVersion(currentVersion) >= _countVersion(targetVersion);
  function _countVersion(version) {
    return version.split('.').reduce(function (a, b) {
      return ~~a * 1000 + ~~b;
    });
  }
}

/**
 * 版本比较 之比较最后一组, 适用于Max+和小黑盒同时存在的页面
 * @param {*} targetVersion 324
 * @param {*} currentVersion
 * @returns
 */
export function geVersionMaxAndHeybox(targetVersion, currentVersion = getUrlParam('version')) {
  let android_version, ios_version;
  if (typeof targetVersion === 'string') {
    android_version = ios_version = targetVersion;
  } else {
    android_version = targetVersion.android;
    ios_version = targetVersion.ios;
  }
  console.log(android_version);

  return _countVersion(currentVersion) >= _countVersion(getOSType() === 'Android' ? android_version : ios_version);
  function _countVersion(version) {
    if (version.includes('.')) {
      return Number(version.split('.')[2]);
    } else {
      return Number(version);
    }
  }
}

// 弹出客户端提示框
export function showMessage(state, msg) {
  if (process.env.NODE_ENV == 'development') {
    console.log(state == 'ok' ? '✅' : '❌', 'showMessage: ', msg);
    return;
  }
  window.location.href =
    'heybox://' +
    encodeURIComponent(
      JSON.stringify({
        protocol_type: 'alert',
        alert_type: 'state',
        state: state,
        desc: msg,
      }),
    );
}

// 判断页面高宽比是否大于1.85
export function isFullScreen() {
  let rate = window.screen.height / window.screen.width;
  let limit = window.screen.height == window.screen.availHeight ? 1.85 : 1.65;
  if (rate > limit) {
    return true;
  }
  if (rate < 1) {
    return true;
  }
  return false;
}

// 获取操作系统
export function getOSType() {
  if (window && window.navigator.userAgent) {
    const ua = window.navigator.userAgent.toLocaleLowerCase();
    if (/(iphone|ipad|ios)/i.test(ua)) {
      return 'iOS';
    } else if (/mac os/i.test(ua)) {
      return 'Mac';
    } else if (/(android)/i.test(ua)) {
      return 'Android';
    } else if (/(harmony|arkweb)/i.test(ua)) {
      return 'ohos';
    } else {
      return 'Windows';
    }
  }
  return '';
}

// 微信分享
export function wxShare(data, share, deepLink = false) {
  let config = {
    debug: false,
    appId: data.appId,
    timestamp: data.timestamp,
    nonceStr: data.nonceStr,
    signature: data.signature,
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'],
  };
  if (deepLink) config.openTagList = ['wx-open-launch-app'];
  wx.config(config);

  wx.ready(function () {
    if (share) {
      // 微信jssdk 1.6.0新增 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx.updateAppMessageShareData({
        title: share.title,
        desc: share.desc,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {},
      });

      // 微信jssdk 1.6.0新增 自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容
      wx.updateTimelineShareData({
        title: share.title,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {},
      });

      //分享到腾讯微博
      wx.onMenuShareWeibo({
        title: share.title,
        desc: share.desc,
        link: share.link,
        imgUrl: share.imgUrl,
        success: function () {},
        cancel: function () {},
      });
    }
  });
}

// 在app外执行协议
export function executeProtocolOutApp(protocol) {
  const ua = window.navigator.userAgent.toLowerCase();
  const client_type = getUrlParam('client_type');
  let formatProtocol = '';
  if (JSON.stringify(protocol).includes('heybox://') || JSON.stringify(protocol).includes('heybox%3A%2F%2F')) {
    formatProtocol = protocol;
  } else {
    formatProtocol = 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
  }
  if (/QQ/i.test(ua) || /Weibo/i.test(ua) || /Android/i.test(ua)) {
    window.location.href = 'https://api.xiaoheihe.cn/open_inapp/#' + formatProtocol;
    return 'https://api.xiaoheihe.cn/open_inapp/#' + formatProtocol;
  } else {
    let host = client_type == 'acc_mobile' ? 'acc.xiaoheihe.cn' : 'c.xiaoheihe.cn';
    window.location.href = 'https://' + host + '/hb_protocol?protocol=' + formatProtocol;
    return 'https://' + host + '/hb_protocol?protocol=' + formatProtocol;
  }
}

// 执行协议异步
export function executeProtocol(protocol) {
  if (process.env.NODE_ENV == 'development') {
    console.log('🚀 invoke protocol:', protocol);
    return;
  }
  if (protocol.constructor == String && protocol.indexOf('heybox://') != -1) {
    protocol = JSON.parse(decodeURIComponent(protocol.replace('heybox://', '')));
  }
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.hbProtocol) {
    window.webkit.messageHandlers.hbProtocol.postMessage(protocol);
  } else if (window.local_obj && window.local_obj.hbProtocol) {
    window.local_obj.hbProtocol('heybox://' + encodeURIComponent(JSON.stringify(protocol)));
  } else {
    window.location.href = 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
  }
  // if (!IS_PRO) {
  //   launchAppByProtocol(9555, protocol, 'iOS')
  // }
}

// os_type: iOS | Android
function launchAppByProtocol(port, protocol, os_type) {
  fetch(`http://localhost:${port}/heybox/launch_heybox?protocol=${encodeURIComponent(JSON.stringify(protocol))}&os_type=${os_type}`)
    .then((res) => res.json())
    .then((res) => {
      console.log('[协议执行]', res);
    });
}

// 同步执行协议
export function executeProtocolSync(protocol) {
  if (process.env.NODE_ENV == 'development') {
    return 88;
  }
  if (!isInHeybox()) {
    return;
  }
  return prompt(' ', 'heybox://' + encodeURIComponent(JSON.stringify(protocol)));
}

// 十六进制转为 rgba的模式
export function hexToRgba(hex, opacity = 1) {
  if (hex) {
    hex = hex.toUpperCase();
    if (hex.length === 4) {
      hex =
        '#' +
        hex
          .split('#')[1]
          .split('')
          .map((item) => item.repeat(2))
          .join('');
    }
    return (
      'rgba(' +
      parseInt('0x' + hex.slice(1, 3)) +
      ',' +
      parseInt('0x' + hex.slice(3, 5)) +
      ',' +
      parseInt('0x' + hex.slice(5, 7)) +
      ',' +
      opacity +
      ')'
    );
  }
}

// 设置页面可视状态变化时的回调
export function pageChange(enterCallback = () => {}, leaveCallback = () => {}) {
  var state, visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    visibilityChange = 'visibilitychange';
    state = 'visibilityState';
  } else if (typeof document.mozHidden !== 'undefined') {
    visibilityChange = 'mozvisibilitychange';
    state = 'mozVisibilityState';
  } else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange';
    state = 'msVisibilityState';
  } else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange';
    state = 'webkitVisibilityState';
  }
  document.addEventListener(
    visibilityChange,
    function () {
      if (document[state] == 'visible') {
        // 回来页面
        setTimeout(() => {
          enterCallback();
        }, 50);
      }
      if (document[state] == 'hidden') {
        // 离开页面
        leaveCallback();
      }
    },
    false,
  );
}

// 深拷贝
export function deepCopy(data) {
  let dataTmp = undefined;
  if (data === null || !(typeof data === 'object')) {
    dataTmp = data;
  } else {
    dataTmp = data.constructor.name === 'Array' ? [] : {};
    for (let key in data) {
      dataTmp[key] = utils.deepCopy(data[key]);
    }
  }
  return dataTmp;
}

// 预加载图片
export function prefetchImage(imgs, ignoreError = false) {
  return new Promise((resolve, reject) => {
    let count = 0,
      len = imgs.length;
    for (let i = 0; i < len; i++) {
      let img = new Image();
      img.src = imgs[i];
      img.onload = function () {
        count++;
        if (count === len) {
          resolve('prefetch');
        }
      };
      img.onerror = function () {
        if (ignoreError) {
          count++;
          if (count === len) {
            resolve('prefetch');
          }
        } else {
          reject(`${imgs[i]} failed to load`);
        }
      };
    }
  });
}

// supportWebp: false,
export function webpFormat(urlObj, quality) {
  return new Promise((resolve) => {
    if (window.SUPPORT_WEBP) {
      urlObj = formatWebpParams(urlObj, quality);
      resolve(urlObj);
    } else {
      var img = new Image();
      img.onload = function () {
        var result = img.width > 0 && img.height > 0;
        if (result) {
          window.SUPPORT_WEBP = true;
          urlObj = formatWebpParams(urlObj, quality);
        }
        resolve(urlObj);
      };
      img.onerror = function () {
        window.SUPPORT_WEBP = false;
        resolve(urlObj);
      };
      img.src =
        'data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA';
    }
  });
}

// 图片url转换成webp格式
export function formatWebpParams(urlObj, quality = 75) {
  let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com\/(?!.*\.(svg|svgz|ico)$).*/;
  if (window.SUPPORT_WEBP) {
    if (typeof urlObj === 'object') {
      Object.keys(urlObj).forEach((key) => {
        if (cdnReg.test(urlObj[key])) {
          let url = urlObj[key].split('?')[0];
          urlObj[key] = `${url}?imageMogr2/format/webp/quality/${quality}/auto-orient/ignore-error/1`;
        }
      });
    } else if (urlObj) {
      if (cdnReg.test(urlObj)) {
        let url = urlObj.split('?')[0];
        urlObj = `${url}?imageMogr2/format/webp/quality/${quality}/auto-orient/ignore-error/1`;
      }
    }
  }
  return urlObj;
}

// y轴先快后慢滚动到指定位置
export function easeOutScrollTo(position = 0, el = null) {
  return new Promise((resolve) => {
    // 不存在原生requestAnimationFrame，用setTimeout模拟替代
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (cb) {
        return setTimeout(cb, 17);
      };
    }
    // 当前滚动高度
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (el) {
      // 容器内滚动情况
      scrollTop = el.scrollTop;
    }
    var step = function () {
      const distance = position - scrollTop;
      scrollTop = scrollTop + distance / 5;
      if (Math.abs(distance) < 1) {
        if (el) {
          el.scrollTo(0, position);
        } else {
          window.scrollTo(0, position);
        }
        // 滚动结束
        setTimeout(() => {
          resolve(1);
        }, 18);
      } else {
        if (el) {
          el.scrollTo(0, scrollTop);
        } else {
          window.scrollTo(0, scrollTop);
        }
        requestAnimationFrame(step);
      }
    };
    step();
  });
}

// 根据json生成DOM
export function getDomByJson(rich, type = 'dom') {
  // 设置属性元组
  const styleMap = {
    width: 'width',
    height: 'height',
    font_name: 'font-family',
    font_size: 'font-size',
    background_color: 'background-color',
    line_height: 'line-height',
    underline_color: 'text-decoration: underline; text-decoration-color',
    color: 'color',
    corner_radius: 'border-radius',
    border_width: 'border-style: solid; border-width',
    border_color: 'border-color',
    text_alignment: 'text-align',
    number_of_lines: 'white-space',
  };
  const valMap = {
    text_alignment: { 0: 'left', 1: 'center' },
    number_of_lines: { 0: 'normal', 1: 'nowrap' },
  };
  let needScale = false;
  let _rich = JSON.parse(JSON.stringify(rich));

  // 查询是否需要缩放
  (function () {
    for (let child of _rich.attrs) {
      if (child.font_size < 10 || _rich.border_width < 1) {
        needScale = true;
      }
    }
    if (needScale) {
      for (let item of _rich.attrs) {
        if (item.font_size) {
          item.font_size *= 2;
        }
        if (item.font_weight) {
          item.font_weight *= 2;
        }
        if (item.width) {
          item.width *= 2;
        }
        if (item.height) {
          item.height *= 2;
        }
      }
      _rich.border_width *= 2;
      _rich.corner_radius *= 2;
      if (_rich.inset) {
        _rich.inset.top *= 2;
        _rich.inset.bottom *= 2;
        _rich.inset.left *= 2;
        _rich.inset.right *= 2;
      }
    }
  })();

  // 添加属性的函数
  const addStyle = function (_rich) {
    let style = '';
    for (let k in _rich) {
      if (k in styleMap) {
        let key = styleMap[k];
        let val = valMap[k] ? valMap[k][_rich[k]] : _rich[k];
        if (typeof val === 'number') {
          val += 'px';
        }
        if (key.match('color')) {
          if (val.indexOf('#') != -1) {
            if (val.length == 9) {
              const a = parseInt(val.slice(1, 3), 16) / 255;
              const r = parseInt(val.slice(3, 5), 16);
              const g = parseInt(val.slice(5, 7), 16);
              const b = parseInt(val.slice(7), 16);
              val = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
            } else {
              const r = parseInt(val.slice(1, 3), 16);
              const g = parseInt(val.slice(3, 5), 16);
              const b = parseInt(val.slice(5), 16);
              val = 'rgba(' + r + ',' + g + ',' + b + ',' + 1 + ')';
            }
          }
        }
        style += key + ':' + val + ';';
      }
    }
    if (_rich.inset) {
      let padding = { top: 0, left: 0, bottom: 0, right: 0, ..._rich.inset };
      style += `padding:${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px;`;
    }
    return style;
  };

  // 添加主dom
  const dom = document.createElement('div');

  // 添加内部元素
  for (let child of _rich.attrs) {
    let childEl;
    switch (child.type) {
      case 'text': {
        childEl = document.createElement('p');
        let style = addStyle(child);
        style += ` white-space: nowrap;`;
        if (child.offset) {
          style += `position: relative; top:${child.offset}px;`;
        }
        childEl.innerText = child.text;
        childEl.style = style;
        break;
      }
      case 'spacer':
        childEl = document.createElement('span');
        childEl.style = addStyle(child) + 'display: inline-block;';
        break;
      case 'image':
        childEl = document.createElement('img');
        childEl.src = child.image;
        childEl.style = addStyle(child) + 'vertical-align: bottom;';
        break;
    }
    dom.appendChild(childEl);
  }

  // 处理父元素样式
  let outerDomStyle = addStyle(_rich);
  if (!_rich.number_of_lines || _rich.number_of_lines === 1) {
    outerDomStyle += `display: inline-flex; justify-content: center;`;
  }
  if (needScale) {
    if (type == 'post') {
      // outerDomStyle += ` transform: scale(0.5); transform-origin: left center;`
    } else {
      outerDomStyle += ` transform: scale(0.5); transform-origin: left top;`;
    }
  }
  switch (_rich.text_alignment) {
    case 0:
      outerDomStyle += `align-items: flex-start;`;
      break;
    case 1:
      outerDomStyle += `align-items: center;`;
      break;
    default:
      outerDomStyle += `align-items: center;`;
  }

  dom.style = outerDomStyle;
  if (_rich.protocol) {
    dom.addEventListener('click', () => {
      window.location.href = _rich.protocol;
    });
  }

  let result = type == 'dom' ? dom : dom.outerHTML;
  return result;
}

// 获取环境类型
export function getEnvType() {
  if (process.env.NODE_ENV === 'production') {
    const url = window.location.href;
    if (url.startsWith('https://heybox.debugmode.cn')) {
      return 'test';
    }
    if (url.startsWith('https://api.xiaoheihe.cn')) {
      return 'pro';
    }
  }
  return 'dev';
}

// 获取url的origin
export function getUrlOrigin() {
  return window.location.origin;
}

// 设置cookie
export function setCookie(name, value) {
  var now = new Date();
  now.setTime(now.getTime() + 14 * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + escape(value) + ';expires=' + now.toGMTString() + ';path=/;domain=' + BASE_DOMAIN;
}

// 获取cookie
export function getCookie(name) {
  const arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
  if (arr != null) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

// 删除cookie
export function delCookie(name) {
  let now = new Date();
  now.setTime(now.getTime() - 100000);
  const cval = utils.getCookie(name);
  if (cval != null) {
    document.cookie = name + '=;expires=' + now.toGMTString() + ';path=/;domain=' + BASE_DOMAIN;
  }
}

// 显示新版Toast
export function showToast(msg, type = 'ok') {
  if (geVersion('1.3.237')) {
    executeProtocol({
      protocol_type: 'showToast',
      type: '1',
      text: msg,
    });
  } else {
    showMessage(type, msg);
  }
}

// 处理请求指向
export function getRequestUrl(path, add_host = true) {
  const white_list = ['webtest', 'login', 'localhost', 'chat', 'hkoa', 'accoriapi', 'accapi'];
  if (white_list.find((host) => window.location.origin.includes(host)) || window.location.origin.match(/\./g).length >= 3) {
    return path;
  }

  // 请求完整url
  if (path.startsWith('http')) {
    if (add_host) {
      return path;
    } else {
      return new URL(path).pathname;
    }
  }
  /* 
    api.xiaoheihe.cn   -  v5api.maxjia.com
    heybox.debugmode.cn   -  v5max.debugmode.cn 
    data.xiaoheihe.cn  -   v5data.maxjia.com 
    web.xiaoheihe.cn   -   v5web.maxjia.com
    web.debugmode.cn  - v5web.debugmode.cn 
  */

  if (origin.match(/\./g)?.length === 1) {
    return origin.replace(/(.*?:\/\/)(.*?)(\..*)/, (url, protocol, host, suffix_host) => {
      let temp_host = '';
      if (host === 'xiaoheihe') {
        temp_host = `${protocol}api.${host}${suffix_host}`;
      } else if (host === 'debugmode') {
        temp_host = `${protocol}heybox.${host}${suffix_host}`;
      }
      return add_host ? temp_host + path : path.replace(temp_host, '');
    });
  } else {
    return origin.replace(/(.*?:\/\/)(.*?)\.(.*?)(\..*)/, (url, protocol, prefix_host, host, suffix_host) => {
      let temp_host = '';
      if (prefix_host.startsWith('v5')) {
        if (host === 'maxjia') {
          temp_host = `${protocol}v5api.${host}${suffix_host}`;
        } else if (host === 'debugmode') {
          temp_host = `${protocol}v5max.${host}${suffix_host}`;
        }
      } else {
        if (host === 'xiaoheihe') {
          temp_host = `${protocol}api.${host}${suffix_host}`;
        } else if (host === 'debugmode') {
          temp_host = `${protocol}heybox.${host}${suffix_host}`;
        }
      }
      return add_host ? temp_host + path : path.replace(temp_host, '');
    });
  }
}

export function redirectUrlByServer(url, to = 'web') {
  if (!url.includes('http')) {
    url = window.location.origin + url;
  }
  switch (to) {
    case 'web': {
      return url.replace(/(heybox|v5max)\.debugmode|(api)\.xiaoheihe|(v5api)\.maxjia/, (_, $1, $2, $3) => {
        if ($1) {
          if ($1 == 'heybox') {
            return _.replace($1, 'web');
          } else {
            return _.replace($1, 'v5web');
          }
        } else if ($2) {
          return _.replace($2, 'web');
        } else if ($3) {
          return _.replace($3, 'v5web');
        }
      });
    }
    case 'heybox': {
      return url.replace(/(web|v5web)\.debugmode|(web)\.xiaoheihe|(v5web)\.maxjia/, (_, $1, $2, $3) => {
        if ($1) {
          if ($1 == 'web') {
            return _.replace($1, 'heybox');
          } else {
            return _.replace($1, 'v5max');
          }
        } else if ($2) {
          return _.replace($2, 'api');
        } else if ($3) {
          return _.replace($3, 'v5api');
        }
      });
    }
  }
}

/**
 * 获取当前环境
 * @returns {
 *  user_id: 123456,
 *  version: 'xxx',
 *  os_type: 'Android' or 'iOS'
 * }
 */
let HEYBOX_ENV;
export function getHeyboxEnv(ignore_version = false) {
  if (HEYBOX_ENV) return HEYBOX_ENV;
  if (ignore_version || geVersion('1.3.261')) {
    if (window.local_obj && window.local_obj.getHeyboxEnv) {
      // Android
      const temp = window.local_obj.getHeyboxEnv() || '{}';
      HEYBOX_ENV = JSON.parse(temp);
    } else {
      // iOS
      HEYBOX_ENV = window.HEYBOX_ENV || {};
    }
  } else {
    HEYBOX_ENV = {};
  }
  return HEYBOX_ENV;
}

// 判断是否在小黑盒
export function isInHeybox() {
  const env = getHeyboxEnv();
  return (env && Object.entries(env).length > 0) || window.location.origin === 'file://';
}

// 根据ASCII码数组生成string
export function transformASCIItoString(arr) {
  var str = '';
  arr.forEach((d) => {
    str += String.fromCharCode(d);
  });
  return str;
}

// 根据string生成ASCII码数组
export function transformStringToASCII(str) {
  var arr = [];
  for (var i = 0; i < str.length; i++) {
    arr.push(str[i].charCodeAt());
  }
  return arr;
}

// 获取数美token
export function getSmDeviceId() {
  return new Promise((resolve) => {
    window.dealSmDeviceId((device_id) => {
      setTimeout(() => {
        resolve(device_id);
      }, 0);
    });
  });
}

export function updateSmTokenByClient() {
  return new Promise((resolve, reject) => {
    window.updateSmCallback = function () {
      resolve();
    };
    try {
      executeProtocol({
        protocol_type: 'onLackToken',
        callback_js: 'updateSmCallback()',
      });
    } catch (err) {
      reject();
    }
  });
}

// 给对象数组去重，指定key
export function uniqueObjectArray(originalArray, key) {
  const uniqueArray = [];
  const keySet = {};

  for (const item of originalArray) {
    if (!keySet[item[key]]) {
      uniqueArray.push(item);
      keySet[item[key]] = true;
    }
  }
  return uniqueArray;
}

export function getRandom(max, min = 0) {
  return ~~(Math.random() * (max - min + 1)) + min;
}

// NOTE 对于已经迁移但入口无法更改的页面（如旧版小程序加入桌面），给出提示
export function showDeprecatedPagePopup() {
  if (process.env.NODE_ENV == 'development' || /.*web\.(xiaoheihe|debugmode).*/.test(window.location.origin)) {
    return;
  }
  executeProtocol({
    protocol_type: 'trackData',
    type: 1,
    path: '/web/migrate/deprecated/stats',
    addition: {
      page: window.location.pathname,
    },
  });
  executeProtocol({
    protocol_type: 'max_alert',
    title: '提示',
    desc: '您当前使用的是旧版小程序，请移除桌面小程序后，在小黑盒内重新添加小程序，体验最新功能！',
    confirm: '确定',
  });
}

export { registerNativeCallback } from '_lib/jsBridge/jsBridgeWeb.js';

export const shuffle = (arr) => {
  let _arr = arr.slice();
  for (let i = 0; i < _arr.length; i++) {
    let j = getRandom(i, 0);
    let t = _arr[i];
    _arr[i] = _arr[j];
    _arr[j] = t;
  }
  return _arr;
};

export function sendClientRequest({ url = '', type = 'GET', query = {}, data = {}, headers = {}, need_encrypt = 1, protocol_options = {} }) {
  const use = 'protocol';
  return new Promise((resolve, reject) => {
    let paths = url.split('/');
    var js_cb_name = `ttt_req_${paths[paths.length - 1]}`;
    console.log('设置回调名', js_cb_name);
    window[js_cb_name] = (res) => {
      console.log(res);
      if (res.error) {
        reject(res.error);
      } else if ((res.responseStatus == 200 && res.content.message == 'OK') || res.content.status != 'failed') {
        resolve(res.content);
      } else if (res.responseStatus) {
        if (res.responseStatus != 200) {
          reject(res.err);
        } else {
          reject(res.content.message);
        }
      } else {
        reject(res.content.msg);
      }
    };
    const option = {
      protocol_type: 'sendRequestV2',
      need_encrypt: need_encrypt,
      type: type,
      show_toast: false,
      query: query,
      headers: headers,
      url: url,
      jsCallbackFunc: js_cb_name,
      ...protocol_options,
    };
    !need_encrypt &&
      type.includes('POST') &&
      Object.assign(headers, {
        'content-type': 'application/x-www-form-urlencoded',
      });
    Object.keys(data).length != 0 && (option.body = data);
    console.log(option);
    executeProtocol(option);
  });
}

/**
 * 游戏绑定行为通用上报, 游戏类型，绑定类型: bind, update，行为类型: try, success
 * gameType: 可通过 https://heyboxoa.maxjia.com/game/dashboard_v2/combat_card/manage 查看
 */
export function reportBindAction(gameType, bindType, actionType, addition = {}) {
  if (!gameType || !bindType || !actionType) {
    return;
  }
  executeProtocol({
    protocol_type: 'trackData',
    type: 4,
    path: `web/game/${gameType}/${bindType}/${actionType}`,
    addition: addition,
  });
}

export function decodeHtmlEntities(str = '') {
  const entities = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
  };
  return str.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, (match) => entities[match]);
}

export class HBStorage {
  static get(key) {
    let value;
    if (isInHeybox()) {
      value = executeProtocolSync({
        protocol_type: 'getStorage',
        key,
      });
    } else {
      value = window.localStorage.getItem(key);
    }
    return value ? JSON.parse(value) : null;
  }

  static set(key, value) {
    if (!key || typeof key !== 'string') throw new TypeError('[key]需要是一个string类型');
    if (!value) throw new Error('值为空');
    value = JSON.stringify(value);

    if (isInHeybox()) {
      executeProtocol({
        protocol_type: 'setStorage',
        value,
        key,
      });
    } else {
      window.localStorage.setItem(key, value);
    }
    return true;
  }

  static remove(key) {
    if (isInHeybox()) {
      executeProtocol({
        protocol_type: 'setStorage',
        value: '',
        key,
      });
    } else {
      window.localStorage.removeItem(key);
    }
    return true;
  }
}

export function judegeCanUseDeepLink() {
  if (isInHeybox()) {
    return false;
  }
  // 微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
  const wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
  if (!wechatInfo) return false;
  let judgewechat = wechatInfo[1].split('.');
  if (judgewechat[0] >= 7 && judgewechat[1] >= 0 && judgewechat[2] >= 12) {
    return true;
  } else {
    return false;
  }
}

function formatTimeToMS(time) {
  time = Number(time);
  if (isNaN(time)) {
    throw new TypeError('create_at格式错误');
  }
  return time < new Date('2000-01-01').getTime() ? time * 1000 : time;
}
export function BBSCreateAtFormat(create_at) {
  const create_at_ms = formatTimeToMS(create_at);
  const SECOND_IN_MILLIS = 1000;
  const MINUTE_IN_MILLIS = SECOND_IN_MILLIS * 60;
  const HOUR_IN_MILLIS = MINUTE_IN_MILLIS * 60;
  const DAY_IN_MILLIS = HOUR_IN_MILLIS * 24;
  const TODAY_MIDNIGHT = moment().startOf('day');
  // const DAY_IN_MILLIS =

  let result = '刚刚';
  let span = Date.now() - create_at_ms;
  if (create_at_ms > TODAY_MIDNIGHT || span < HOUR_IN_MILLIS * 2) {
    if (span > HOUR_IN_MILLIS) {
      result = `${Math.round(span / HOUR_IN_MILLIS)}小时前`;
    } else if (span > MINUTE_IN_MILLIS) {
      result = `${Math.round(span / MINUTE_IN_MILLIS)}分钟前`;
    } else if (span > SECOND_IN_MILLIS) {
      result = '刚刚';
    }
  } else if (create_at_ms > TODAY_MIDNIGHT - DAY_IN_MILLIS) {
    result = moment(create_at_ms).format('昨天HH:mm');
  } else if (create_at_ms > TODAY_MIDNIGHT - DAY_IN_MILLIS * 2) {
    result = moment(create_at_ms).format('2天前');
  } else if (create_at_ms > TODAY_MIDNIGHT - DAY_IN_MILLIS * 3) {
    result = moment(create_at_ms).format('3天前');
  } else if (moment(create_at_ms).isSameOrAfter(moment(), 'year')) {
    result = moment(create_at_ms).format('MM-DD');
  } else {
    result = moment(create_at_ms).format('YYYY-MM-DD');
  }
  return result;
}
